import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, Gamepad2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const CONSENT_KEY = "hb_cookie_consent";

export default function MobileCTA() {
  const [visible, setVisible] = useState(false);
  const { lang } = useLanguage();

  useEffect(() => {
    const check = () => {
      const consent = localStorage.getItem(CONSENT_KEY);
      const scrolled = window.scrollY > 500;
      setVisible(!!consent && scrolled);
    };
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("storage", check);
    check();
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("storage", check);
    };
  }, []);

  return (
    <div
      data-testid="mobile-sticky-cta"
      className={`fixed left-0 right-0 z-40 transition-transform duration-300 ease-out ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{
        bottom: 0,
        background: "rgba(11,12,14,0.97)",
        backdropFilter: "blur(12px)",
        borderTop: "1px solid rgba(245,200,0,0.15)",
        boxShadow: "0 -8px 32px rgba(0,0,0,0.35)",
      }}
    >
      <div className="container-hb py-2.5 flex items-center justify-between gap-4">
        <a
          href="tel:+390473238030"
          data-testid="mobile-sticky-phone"
          className="flex items-center gap-2.5 text-white/50 hover:text-hb-yellow transition-colors duration-200 min-w-0"
        >
          <div
            className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
            style={{ background: "rgba(245,200,0,0.12)" }}
          >
            <Phone size={13} className="text-hb-yellow" />
          </div>
          <span className="text-xs font-inter font-semibold tracking-wide hidden sm:block">
            +39 0473 238 030
          </span>
          <span className="text-xs font-inter font-semibold tracking-wide sm:hidden">
            {lang === 'it' ? 'Chiama' : 'Anrufen'}
          </span>
        </a>

        <div className="flex items-center gap-3">
          <span
            className="text-[9px] tracking-widest uppercase font-inter hidden md:block"
            style={{ color: "rgba(255,255,255,0.2)" }}
          >
            Holzbuddy · Meran
          </span>
          <Link
            to="/spiel"
            data-testid="mobile-sticky-spiel"
            title="Holzbuddy.tetris spielen"
            className="hidden md:flex items-center justify-center w-9 h-9 transition-colors duration-200 flex-shrink-0"
            style={{
              border: "1px solid rgba(245,200,0,0.45)",
              color: "#f5c800",
              animation: "ctaPulseRing 1.8s ease-out infinite",
            }}
            onMouseEnter={e => { e.currentTarget.style.animation = "none"; e.currentTarget.style.borderColor = "rgba(245,200,0,0.9)"; }}
            onMouseLeave={e => { e.currentTarget.style.animation = "ctaPulseRing 1.8s ease-out infinite"; e.currentTarget.style.borderColor = "rgba(245,200,0,0.45)"; }}
          >
            <Gamepad2 size={14} />
          </Link>
          <Link
            to="/anfrage"
            data-testid="mobile-sticky-anfrage"
            className="btn-primary text-xs px-5 py-2.5 whitespace-nowrap"
          >
            {lang === 'it' ? 'Richiedi progetto' : 'Projekt anfragen'}
          </Link>
        </div>
      </div>
    </div>
  );
}
